import React from "react";
import Box from "@mui/material/Box";
import { Modal } from "@mui/material";
import Select from "@mui/material/Select";
import { PopUpContainer } from "assets/css/globle";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const LanguageWrapper = styled.div`
  padding: 0 20px 30px;

  .MuiInputBase-root {
    width: 100%;
  }

  .MuiNativeSelect-select {
    font-size: 14px;
    padding: 7.5px 14px;
  }
`;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "400px",
  width: "calc(100% - 40px)",
  bgcolor: "background.paper",
  borderRadius: "5px",
  overflow: "hidden",
};

export const LanguageModal = ({
  open,
  onClose,
  language,
  setLanguage,
  onConfirm,
}) => {
  const { t } = useTranslation();

  const languagesList = {
    NameEn: "English",
    Namebg: "Български",
    Namezh: "中文(简体)",
    Namezk: "中文(繁體)",
    Namede: "Deutsch",
    Namees: "Español",
    Namefr: "Français",
    Nameja: "日本語",
    Nameko: "한국어",
    Nameru: "русский",
    Namecs: "čeština",
  };

  const languageListValue = {
    Langen: "enUS",
    Langbg: "bgBG",
    Langzh: "zhCN",
    Langzk: "zhHK",
    Langde: "deDE",
    Langes: "esES",
    Langfr: "frFR",
    Langja: "jaJP",
    Langko: "koKR",
    Langru: "ruRU",
    Langcs: "csCZ",
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <PopUpContainer>
          <h2>{t("Language")}:</h2>

          <LanguageWrapper>
            <Select
              native
              id="language-select"
              variant="outlined"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value={languageListValue.Langen}>
                {languagesList.NameEn}
              </option>

              <option value={languageListValue.Langbg}>
                {languagesList.Namebg}
              </option>

              <option value={languageListValue.Langzh}>
                {languagesList.Namezh}
              </option>

              <option value={languageListValue.Langzk}>
                {languagesList.Namezk}
              </option>

              <option value={languageListValue.Langde}>
                {languagesList.Namede}
              </option>

              <option value={languageListValue.Langes}>
                {languagesList.Namees}
              </option>

              <option value={languageListValue.Langfr}>
                {languagesList.Namefr}
              </option>

              <option value={languageListValue.Langja}>
                {languagesList.Nameja}
              </option>

              <option value={languageListValue.Langko}>
                {languagesList.Nameko}
              </option>

              <option value={languageListValue.Langru}>
                {languagesList.Nameru}
              </option>

              <option value={languageListValue.Langcs}>
                {languagesList.Namecs}
              </option>
            </Select>
          </LanguageWrapper>

          <div className="action-btn">
            <button onClick={onConfirm} className="primary">
              {t("Ok")}
            </button>

            <button onClick={onClose}>
              {t("Cancel")}
            </button>
          </div>
        </PopUpContainer>
      </Box>
    </Modal>
  );
};